import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UIDesignerModule, UITypeInterfaceBuilderModule, UIOverlayModule, UITypeInterfaceFormModule } from 'buzzyears.ui';

import { WorkflowDesignerComponent } from './workflow-designer.component';
import { WorkflowGraphModule } from '../graph';
import { WorkflowDesignerDispatcherService } from './workflow-designer-dispatcher.service';
import { WorkflowVertexLibraryModule } from '../vertex-library';
import { WorkflowDesignerVertexConnectionComponent, WorkflowDesignerVertexPropertiesComponent } from './vertex';
import { WorkflowDesignerTestComponent } from './workflow-designer-test.component';

const EXTERNAL_COMPONENTS = [
  WorkflowDesignerComponent
];

const INTERNAL_COMPONENTS = [
  WorkflowDesignerVertexPropertiesComponent,
  WorkflowDesignerVertexConnectionComponent,
  WorkflowDesignerTestComponent
];

const COMPONENTS = [ ...INTERNAL_COMPONENTS, ...EXTERNAL_COMPONENTS ];

@NgModule({
  imports: [
    CommonModule,
    WorkflowGraphModule,
    WorkflowVertexLibraryModule,
    UIDesignerModule,
    FormsModule,
    UIOverlayModule,
    UITypeInterfaceBuilderModule,
    UITypeInterfaceFormModule,
  ],
  declarations: COMPONENTS,
  exports: EXTERNAL_COMPONENTS,
  providers: [
    WorkflowDesignerDispatcherService
  ],
  entryComponents: [ WorkflowDesignerComponent ]
})
export class WorkflowDesignerModule {

}



// WEBPACK FOOTER //
// ./src/library/designer/workflow-designer.module.ts